import "core-js/modules/es.object.keys.js";
var getThreshold = function getThreshold() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    base: 0,
    sm: undefined,
    md: undefined,
    lg: undefined,
    xl: undefined
  };
  var breakpointKeys = Object.keys(breakpoints);
  var result = breakpointKeys[0];

  // loop through the breakpoint keys to find the last breakpoint that is greater than the width
  for (var i = 1; i < breakpointKeys.length; i++) {
    // the current threshold breakpoint value
    var threshold = breakpoints[breakpointKeys[i]];
    if (width >= threshold) {
      result = breakpointKeys[i];
    } else {
      // since the breakpoints are in order once we have passed where the width is greater than the threshold being
      // checked there is no reason to continue checking as they will all be larger
      break;
    }
  }
  return result;
};
export default getThreshold;